import Logo from '../assets/logo.svg'
import Stars from '../assets/stars.svg'
import History from '../assets/history.svg'
import Settings from '../assets/settings.svg'
import AIStar from '../assets/ai.svg'
import TabStar from '../assets/tab_star.svg'
import Clip from '../assets/clip.svg'
import StarWhite from '../assets/star_white.svg'
import TaskIcon from '../assets/taksIcon.svg'
import ClipBottom from '../assets/clip_bottom.svg'
import Fold from '../assets/fold.svg'
import Tasks from '../assets/tasks.svg'
import Files from '../assets/files.svg'
import SMS from '../assets/sms.svg'
import File from '../assets/file.svg'
import PDFStar from '../assets/pdfstart.svg'
import PDF from '../assets/pdf.png'
import Person from '../assets/person.png'
import Calendar from '../assets/calendar.svg'
import pdfLogo from '../assets/pdfLogo.png'
import Chips from '../assets/Chips.svg'
import ChatLogo from '../assets/chatlogo.png'
import ChatSelected from '../assets/chat_selected.png';
import ChatUnselected from '../assets/chat_unselected.png';
import AILOGO from '../assets/aispaceslogo.png'
import BKILOGO from '../assets/logo.svg'
import SearchImage from '../assets/search.png'
import CommentImage from '../assets/Comment.png'
import CopyImage from '../assets/copy.png'
import Arrow from '../assets/arrow.png'
import BKIPDFLOGO from '../assets/pdfLogo.png'



const constants = {
  ailogo:AILOGO,
  logo: Logo,
  stars: Stars,
  history: History,
  settings: Settings,
  tabStar: TabStar,
  clip: Clip,
  ai: AIStar,
  starWhite: StarWhite,
  tasksIcon: TaskIcon,
  clipBottom:ClipBottom,
  fold:Fold,
  tasks:Tasks,
  files:Files,
  sms:SMS,
  pdfStar:PDFStar,
  pdf:PDF,
  person:Person,
  calendar:Calendar,
  file:File,
  pdfLogo:pdfLogo,
  chips:Chips,
  chatLogo:ChatLogo,
  copyimage:CopyImage,
  commentimage:CommentImage,
  searchimage:SearchImage,
  arrow:Arrow,
  bkipdflogo:BKIPDFLOGO,
  chatSelected: ChatSelected,
  chatUnselected: ChatUnselected,
}

export const colorSchems = {
  yellow: '#5F6368',
  green: '#00C781',
  blue: '#00C781',
  red: '#FF0000',
  aispace: 'var(--aispace-color, #5F6368)'
};

export const getInitials = (name) => {
  const nameParts = name?.split(' ');
  let initials = '';
  nameParts?.forEach(part => {
    initials += part.charAt(0).toUpperCase();
  });
  return initials;
};

// export const BASE_QUERYURL = 'http://localhost:8000/query';
// export const BASE_FILEURL = 'http://localhost:8000/file';
// export const BASE_URL = 'http://localhost:8000/api';
// export const BASE_CHATURL = 'http://localhost:8000/c';
// export const BASE_SETTINGS_URL = 'http://localhost:8000/settings';

// export const BASE_TASK_STATUS = 'http://localhost:8000/task-status';

export const BASE_SETTINGS_URL = '/settings';
export const BASE_FILEURL = '/file';
export const BASE_QUERYURL = '/query';
export const BASE_URL = '/api';
export const BASE_CHATURL = '/c';
export const BASE_TASK_STATUS = '/task-status';

export default constants